import { useAppSelector } from "@/hooks/redux";
import {
    selectCheckoutByOrderId,
    selectCheckoutCompletedByOrderId,
    selectPointById,
    selectTaskById,
} from "@/store/slices/work";

export const usePointSelector = (pointId: string) =>
    useAppSelector((state) => selectPointById(state, pointId));

export const useTaskSelector = (pointId: string, taskId: string) =>
    useAppSelector((state) =>
        selectTaskById(state, { targetId: pointId, taskId }),
    );

export const useCheckoutSelector = (orderId: string) =>
    useAppSelector((state) => selectCheckoutByOrderId(state, orderId));

export const useCheckoutCompletedSelector = (orderId: string) =>
    useAppSelector((state) => selectCheckoutCompletedByOrderId(state, orderId));
